// import { toast } from "react-toastify";

// export const showToast = {
//   success: (message, duration = "short") => {
//     if (message) {
//       toast.success(message, {
//         autoClose: duration === "short" ? 300 : 500,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: false,
//       });
//     }
//   },
//   error: (message, duration = "long") => {
//     if (message) {
//       toast.error(message, {
//         autoClose: duration === "long" ? 500 : 300,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: false,
//       });
//     }
//   },
//   info: (message, duration = "short") => {
//     if (message) {
//       toast.info(message, {
//         autoClose: duration === "short" ? 300 : 500,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: false,
//       });
//     }
//   },
// };

import { toast } from "react-toastify";

const defaultConfig = {
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: false,
  pauseOnFocusLoss: false,
  draggable: false,
};

export const showToast = {
  success: (message) => {
    if (message) toast.success(message, defaultConfig);
  },
  error: (message) => {
    if (message) toast.error(message, defaultConfig);
  },
  info: (message) => {
    if (message) toast.info(message, defaultConfig);
  },
};

